var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LayoutPublic",
    { attrs: { containerWidth: 980, showLang: false } },
    [
      _c(
        "h1",
        {
          staticClass: "text-xl font-semibold mb-4",
          staticStyle: { "line-height": "inherit" },
        },
        [_vm._v("\n    Politique de confidentialité\n  ")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "text-muted" }, [
        _vm._v("Mise à jour le 01/02/2024."),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-5" }, [
        _vm._v(
          "\n    Pour fonctionner de manière optimale " +
            _vm._s(_vm.brand) +
            " peut vous demander la\n    permission d'utiliser certaines informations ou fonctionalités de votre\n    smartphone. Vous trouverez ci-dessous les permissions demandées et\n    l'utilisation destinée.\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "h2",
        {
          staticClass: "text-lg font-semibold mb-4",
          attrs: { id: "permissions" },
        },
        [_vm._v("\n    Permissions requises\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "px-4 mb-3",
          staticStyle: { overflow: "auto", "margin-inline": "-1.5rem" },
        },
        [
          _c(
            "table",
            {
              staticClass: "table text-sm",
              staticStyle: { "min-width": "600px" },
            },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { width: "25%" } }, [_vm._v("Permission")]),
                  _vm._v(" "),
                  _c("th", { attrs: { width: "10%" } }, [_vm._v("Android")]),
                  _vm._v(" "),
                  _c("th", { attrs: { width: "10%" } }, [_vm._v("iOS")]),
                  _vm._v(" "),
                  _c("th", { attrs: { width: "55%" } }, [
                    _vm._v("Utilisation"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v("Position de l'appareil")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("p", [
                      _vm._v(
                        "\n              Utilisée uniquement lorsque la surveillance est active afin de\n              connaître votre position (par GPS, Wi-Fi, Bluetooth Low Energy\n              et/ou par réseau cellulaire).\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n              En cas d'alerte, cette information peut être transmise à un\n              "
                      ),
                      _c("a", { attrs: { href: "#tiers-habilite" } }, [
                        _vm._v("tiers habilité"),
                      ]),
                      _vm._v(
                        " afin que les\n              secours soient guidés jusqu'à vous.\n            "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Bluetooth")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("p", [
                      _vm._v(
                        "\n              Utilisée uniquement lorsque la surveillance est active afin de\n              vous positionner grâces aux technologies liées aux beacons\n              bluetooth low energy.\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n              Cette information peut être transmise à un\n              "
                      ),
                      _c("a", { attrs: { href: "#tiers-habilite" } }, [
                        _vm._v("tiers habilité"),
                      ]),
                      _vm._v(
                        " afin que les\n              secours soient guidés jusqu'à vous.\n            "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Caméra")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("\n            Utilisée pour :\n            "),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "\n                Le flash de l'appareil photo avant Android 6.0 et ainsi\n                signifier qu'une alarme s'est déclenchée.\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [_vm._v("Détecter les QR code")]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Microphone")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            Utilisé pour laisser des instructions vocales (optionnel) lors de\n            l'entrée en zone blanche.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("SMS")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-times text-red-500",
                      attrs: { "aria-label": "Non" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("\n            Utilisée pour :\n            "),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "\n                Envoyer les alertes par SMS au numéro que vous avez configuré\n                en version gratuite\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n                Envoyer des SMS d'alertes à votre télésurveilleur si vous en\n                avez configuré un.\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n                Envoyer un SMS à notre plateforme depuis votre smartphone lors\n                de l'activation d'une licence professionnelle afin d'être en\n                mesure de connaître votre numéro de téléphone qui peut être\n                utilisé pour vous joindre en cas d'alerte ou de perte de\n                liaison si la connexion de données ne fonctionne pas.\n              "
                        ),
                      ]),
                    ]),
                    _vm._v(
                      "\n            Votre numéro peut également être partagé avec un\n            "
                    ),
                    _c("a", { attrs: { href: "#tiers-habilite" } }, [
                      _vm._v("tiers habilité"),
                    ]),
                    _vm._v(
                      " qui serait chargé de\n            piloter les secours.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Liste de contacts")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-times text-red-500",
                      attrs: { "aria-label": "Non" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("p", [
                      _vm._v(
                        "\n              Utilisée uniquement pour choisir un contact pour la levée de\n              doute en mode Freemium.\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n              La liste des contacts n'est en aucun cas téléversée ou stockée\n              vers les serveurs.\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n              Le numéro de contact choisi pour la levée de doute n'est en\n              aucun cas téléversé ou stocké sur les serveurs.\n            "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Téléphone")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-times text-red-500",
                      attrs: { "aria-label": "Non" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("\n            Utilisée pour :\n            "),
                    _c("ul", [
                      _c("li", [
                        _c("span", [_vm._v("Avoir accès à l'envoi de SMS")]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n                Appeler pour vous des numéros présents dans le répertoire\n                partagé d'entreprise.\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n                Répondre aux appels automatiquement lorsque l'option décroché\n                automatique est activée\n              "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Service d'accessibilité")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-times text-red-500",
                      attrs: { "aria-label": "Non" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("\n            Utilisée pour :\n            "),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "\n                Détecter les appuis longs sur les boutons de volume et ainsi\n                déclencher les alertes agression\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n                Afficher le bouton SOS virtuel et les alertes par dessus\n                l'écran de verrouillage et les notifications sur Android 8.0+\n                >\n              "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Accès aux notifications")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-times text-red-500",
                      attrs: { "aria-label": "Non" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            Nécessaire pour répondre aux appels entrants lorsque l'option\n            décroché automatique est activée sur les appareils sous Android\n            5.0 à 7.1.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Rythme cardiaque")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-times text-red-500",
                      attrs: { "aria-label": "Non" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("\n            Utilisée pour :\n            "),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "\n                Uniquement lors d'une alerte, envoyer votre rythme cardiaque\n                afin d'apporter la meilleure prise en charge possible.\n              "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Numéro de téléphone")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-times text-red-500",
                      attrs: { "aria-label": "Non" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            Utilisé pour l'option \"décrochage automatique\" en cas d'alerte.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("Nom & email")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("i", {
                      staticClass: "fa fa-check text-success-600",
                      attrs: { "aria-label": "Oui" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            Mode Freemium : utilisé à des fins analytiques et marketing, dans\n            le cas ou plusieurs personnes font partie d'une même entreprise ou\n            s'inscrivent avec la même adresse mail, on pourra vous proposer de\n            passer au mode Premium.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [_c("td", { attrs: { colspan: "4" } })]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("small", { staticClass: "d-block" }, [
        _c("strong", { attrs: { id: "tiers-habilite" } }, [
          _vm._v("Tiers habilité: "),
        ]),
        _vm._v(
          "\n    Un tiers habilité est une personne physique (personne responsable de\n    l'exploitation des DATI dans votre entreprise par exemple) ou une\n    organisation (télésurveilleur par exemple) qui est chargée de traiter les\n    alertes remontées. Les données vous concernant associées à l'alerte\n    (position, numéro de téléphone, etc.) sont utilisées pour vous contacter\n    et/ou avoir le plus d'informations contextuelles sur le lieu de l'accident\n    afin d'y envoyer les secours.\n  "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }